module.exports = __webpack_public_path__ + "img/b5.fd14adb0.png";